// extracted by mini-css-extract-plugin
export default {"cls1":"buttonStyles-cls1_GVy","cls2":"buttonStyles-cls2__vi buttonStyles-cls1_GVy"};